export default __webpack_public_path__ + "static/media/def-image.4b4211cb.svg";